module.exports = __webpack_public_path__ + "static/media/three-dots.7627bc82.svg";